import axios from "axios";

export const updateNotification = async notification => {
    const response = await axios.put(`/api/services-notification/close`, { notification });
    return response.data;
};

export const getNotification = async id => {
    const response = await axios.get(`/api/services-notification/${id}`);
    return response.data;
};

export const notify = async (notification, type) => {
    const response = await axios.post(`/api/services-notifysend`, { notification, type });
    return response.data;
}
